import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Mail, FileText } from "lucide-react";
import { THERAPIST } from "@/data/catalog";

// Trio d'actions présent partout : Réserver, Commander par courriel, Demander un devis.
// Un contexte (page produit / entreprise / événement / ville) peut personnaliser
// le sujet et le corps du courriel via les props.
export default function ReserveButton({
    label = "Réserver ma séance",
    size = "default",
    className = "",
    mailSubject = "Réservation — Massothérapie Jérémy Tessier",
    mailBody =
        "Bonjour Jérémy,\n\nJe souhaite réserver une séance de massage.\n\n• Soin souhaité : \n• Date envisagée : \n• À domicile ou en clinique : \n\nMerci !",
    quoteSubject = "Demande de devis — Jérémy Tessier",
    quoteBody =
        "Bonjour Jérémy,\n\nJe souhaite obtenir un devis.\n\n• Contexte (entreprise, événement, à domicile, autre) : \n• Date envisagée : \n• Nombre de participants : \n• Durée souhaitée : \n\nMerci !",
}) {
    const sizeClass =
        size === "large"
            ? "px-10 py-7 text-lg"
            : size === "small"
              ? "px-6 py-4 text-sm"
              : "px-8 py-6 text-base";
    const secondarySize =
        size === "large"
            ? "px-8 py-6 text-base"
            : size === "small"
              ? "px-5 py-3.5 text-sm"
              : "px-6 py-5 text-sm";

    const mailHref = `mailto:${THERAPIST.email}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`;
    const quoteHref = `mailto:${THERAPIST.email}?subject=${encodeURIComponent(quoteSubject)}&body=${encodeURIComponent(quoteBody)}`;

    return (
        <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="booking-actions">
            <a href="/#reservation" data-testid="reserve-cta">
                <Button
                    className={`rounded-full bg-[#EF6B4E] hover:bg-[#D9553A] text-white shadow-[0_10px_30px_rgba(239,107,78,0.35)] transition-all hover:-translate-y-0.5 ${sizeClass}`}
                >
                    {label} <ArrowRight size={16} className="ml-2" />
                </Button>
            </a>
            <a href={mailHref} data-testid="mail-order-cta">
                <Button
                    variant="outline"
                    className={`rounded-full border-[#3D8C95] text-[#3D8C95] hover:bg-[#3D8C95] hover:text-white transition-all ${secondarySize}`}
                >
                    <Mail size={14} className="mr-2" />
                    Commander par courriel
                </Button>
            </a>
            <a href={quoteHref} data-testid="quote-cta">
                <Button
                    variant="outline"
                    className={`rounded-full border-[#2C2A29] text-[#2C2A29] hover:bg-[#2C2A29] hover:text-white transition-all ${secondarySize}`}
                >
                    <FileText size={14} className="mr-2" />
                    Demander un devis
                </Button>
            </a>
        </div>
    );
}
